import { downloadFile } from '@mi-front/core';
import { apiClient } from '../../../../../api';

// This file previously contained Redux thunk actions that have been migrated to hooks.
// See: apps/app/src/modules/audit/modules/station-audit/hooks/useAuditPlayback.ts

/** Starts a forced audit-audio download in the same tab (attachment response). */
export function auditDownloadAudio(p: { stationId: string; customId: string }) {
  downloadFile(
    apiClient.audit.getDownloadAudioUrl({
      ...p,
      download: true,
    }),
    false,
  );
}
